const SORT = {
  NEWEST: "recency_desc",
  PRICE_ASC: "price_asc",
  PRICE_DESC: "price_desc",
};

const getLabel = (status: (typeof SORT)[keyof typeof SORT]) => {
  switch (status) {
    case SORT.NEWEST:
      return "Newest First";

    case SORT.PRICE_ASC:
      return "Price -- Low to High";

    case SORT.PRICE_DESC:
      return "Price -- High to Low";
  }
};

export { SORT, getLabel };
